import React from "react";

const WhatsappIcon = () => {
  return (
    <>
      <div className="whatsapp_float">
        <a href="https://wa.me/917987667358" target="_blank">
          <img
            src="./assets/WhatsappLogo.png"
            width="50px"
            className="whatsapp_float_btn"
          />
          <section className="bg-accent border-bottom add-top-margin" style={{ marginTop: "" }}>
            <div className="">
              <div className="row no-gutters d-flex align-items-center" style={{}}>
                {/* <div className="col-lg-2 col-md-3 col-sm-4 col-6">
                  <div className="topic-box topic-box-margin">Top Stories</div>
                </div> */}
                <div className="col-lg-12 col-md-9 col-sm-8 col-12 mt-lg-5">
                  <div className="feeding-text-dark">
                    <p id="sample" className="ticker">
                      <li style={{ color: "red" }}>
                        <marquee width="" direction="left" height="">
                          <b>1. यदि आप अपनी कोई खबर, सार्वजनिक सूचना, गुमशुदा, नाम परिवर्तन सूचना, बिजनेस आइडिया, रिसर्च रिपोर्ट, विज्ञापन, जन्मदिवस, पुण्यतिथि, सालगिरह की बधाईयाॅ प्रकाशित कराना चाहते है तो आप हमसे 7987667358 पर संपर्क या व्हाट्सअप कर सकते है। अथवा डिटेल्स के साथ डाक्यूमेन्ट्स अटेच कर starnewsnetworks1988@gmail.com पर ईमेल करें। धन्यवाद
                            2. अगर आप हमसे जुड़ना चाहते है या कोई विज्ञापन देना चाहते है या हमें कोई सुझाव देना चाहते है तो हमसे मो0न0 7987667358 पर संपर्क या व्हाट्सअप करें|</b>
                        </marquee>

                      </li>
                      <li>
                        <a href="#">Magnificent Image Of The New Hoover Dam Bridge Taking Shape</a>
                      </li>
                      <li>
                        <a href="#">If Obama Had Governed Like This in 2017 He'd Be the
                          Transformational.</a>
                      </li>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </a>

      </div>



    </>
  );
};

export default WhatsappIcon;
